import React from "react";

import { Loading } from "components/Loading";

import { useSetupMyHub } from "./hooks";

function HubSetupLoader() {
  const { loading } = useSetupMyHub();

  return (
    <Loading
      active={loading}
      messages={[
        "We're getting everything ready to make your hub shine",
        "Just a quick setup and you'll be on your way to a wonderful experience!",
      ]}
    />
  );
}

export default HubSetupLoader;
